module.exports = __webpack_public_path__ + "media/images/img_close-e1b589da84968c46997673b603809be0.png";